/**
 * Leer más — descripciones de collection
 *
 * Busca <hr class="cd-cut"> dentro de la descripción, mueve todo lo que
 * viene después a un contenedor plegable y añade el botón.
 *
 * Marcador: hr.cd-cut. Un <hr> sin esa clase se ignora, así que las
 * collections que todavía no usan el sistema nuevo no se ven afectadas.
 */
(function () {
  'use strict';

  var CUT = 'hr.cd-cut, hr.px-cut';
  var MORE_CLASS = 'cata-description__more';
  var BTN_CLASS = 'cd-readmore';
  var LABEL_OPEN = 'Leer más';
  var LABEL_CLOSE = 'Leer menos';

  function init() {
    var cuts = document.querySelectorAll(CUT);

    for (var i = 0; i < cuts.length; i++) {
      build(cuts[i], i);
    }
  }

  function build(cut, index) {
    var container = cut.parentElement;

    if (!container || container.hasAttribute('data-readmore-ready')) return;
    container.setAttribute('data-readmore-ready', '');

    var more = document.createElement('div');
    more.className = MORE_CLASS;
    more.id = MORE_CLASS + '-' + index;
    more.hidden = false;

    var node = cut.nextSibling;
    while (node) {
      var next = node.nextSibling;
      more.appendChild(node);
      node = next;
    }

    cut.parentNode.replaceChild(more, cut);

    if (!more.textContent.trim()) {
      more.remove();
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = BTN_CLASS;
    btn.textContent = LABEL_OPEN;
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', more.id);
    container.appendChild(btn);

    collapse(more);

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';

      if (open) {
        collapse(more, true);
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = LABEL_OPEN;
      } else {
        expand(more);
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = LABEL_CLOSE;
      }
    });
  }

  function collapse(el, animate) {
    if (animate) {
      el.style.maxHeight = el.scrollHeight + 'px';
      // Fuerza un reflow para que la transición arranque desde la altura real
      void el.offsetHeight;
    }

    el.style.maxHeight = '0px';
    el.setAttribute('data-collapsed', 'true');
  }

  function expand(el) {
    el.setAttribute('data-collapsed', 'false');
    el.style.maxHeight = el.scrollHeight + 'px';

    // Al terminar se libera el límite: si dentro hay un acordeón de FAQ
    // que el visitante abre después, el contenido no queda recortado.
    var done = function (event) {
      if (event.propertyName !== 'max-height') return;
      if (el.getAttribute('data-collapsed') === 'true') return;

      el.style.maxHeight = 'none';
      el.removeEventListener('transitionend', done);
    };

    el.addEventListener('transitionend', done);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
